import { useQuery } from '@tanstack/react-query';

import { RQ_BAG_BASIC_KEY } from '../ReactQuery/cacheKeys';
import { useCurrentUser } from '../user/useCurrentUser';

import { getBagBasic } from './helpers';
import { type BagBasicQueryResult } from './types';

export function useBagBasic() {
  const [authenticated] = useCurrentUser();

  const query = useQuery<BagBasicQueryResult>({
    queryKey: [RQ_BAG_BASIC_KEY],
    queryFn: async () => {
      const res = await getBagBasic(authenticated);

      return {
        count: res.count,
        products: res.products,
      };
    },
  });

  return { query };
}
